<template>
<div>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">
        <v-card>
            <div class="pa-3">
                <v-row>
                    <v-col cols="12">
                        <div class="d-flex justify-space-between align-center">
                            <h3>แก้ไขล๊อตเข้า</h3>
                            <v-btn class="grad-primary-bg white--text" height="50" width="20%" @click="$router.push('/alllot')">
                                ย้อนกลับ
                            </v-btn>
                        </div>

                        <div class="grid_lot_detail_in_edit_list mt-2">
                            <div class="grid_lot_detail_in_edit_list">
                                <div>รหัสล๊อตเข้า</div>
                                <div>{{ lot_detail.lot_code }}</div>
                                <div>วันที่</div>
                                <div>{{ lot_detail.dateTime }}</div>
                            </div>

                            <div class="grid_lot_detail_in_edit_list">
                                <div>รหัสใบสั่งซื้ออ้างอิง</div>
                                <div>{{ lot_detail.refer }}</div>
                                <div>ผู้ตรวจสอบของเข้า</div>
                                <div>{{ lot_detail.user_name }}</div>
                            </div>
                        </div>
                        <v-tabs grow>
                            <v-tab @click="page(source_detail.id)" v-for="(source_detail,index) in data" :key="index">{{ source_detail.source_name }}</v-tab>
                        </v-tabs>
                        <div class="mt-2">
                            <v-form ref="form_add" @submit.prevent="lotInUpdate()">
                                <div v-for="(detail,index) in data" :key="index">
                                    <v-simple-table v-if="page_id == detail.id">
                                        <thead>
                                            <tr>
                                                <th class="text-center border_header_lot_detail_in_edit_list">
                                                    #
                                                </th>
                                                <th class="text-center border_header_lot_detail_in_edit_list">
                                                    วัตถุดิบ
                                                </th>
                                                <th class="text-center border_header_lot_detail_in_edit_list">
                                                    จำนวน
                                                </th>
                                                <th class="text-center border_header_lot_detail_in_edit_list">
                                                    หน่วยนับ
                                                </th>
                                                <th class="text-center border_header_lot_detail_in_edit_list">
                                                    ราคาต่อหน่วย
                                                </th>
                                                <th class="text-center border_header_lot_detail_in_edit_list">
                                                    สรุปรายการ
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody v-for="(type_detail,index_type) in detail.typeList" :key="index_type">
                                            <tr>
                                                <td colspan="6" class="primary white--text">
                                                    <div>
                                                        {{ type_detail.type_name }}
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr v-for="(mat_detail,index_mat_detail) in type_detail.detailList" :key="index_mat_detail">
                                                <td class="text-center border_header_lot_detail_in_edit_list">{{ index_mat_detail + 1 }}</td>
                                                <td class="text-center border_header_lot_detail_in_edit_list">{{ mat_detail.mat_name }}</td>
                                                <td class="text-center border_header_lot_detail_in_edit_list">
                                                    <v-text-field type="number" @keypress="isNumberPrice($event)" onpaste="return false" v-model="mat_detail.quantity" hide-details="auto" :rules="[v => !!v || 'กรุณากรอกจำนวน']" required dense outlined></v-text-field>
                                                </td>
                                                <td class="text-center border_header_lot_detail_in_edit_list">
                                                    <!-- <v-select v-model="mat_detail.unit_type" :items="mat_detail.unit_type_list" item-text="unit_type_name" item-value="id" hide-details="auto" dense outlined>
                                                    </v-select> -->
                                                    {{ mat_detail.unit_type_list.find((detail) => { return detail.id == mat_detail.unit_type }).unit_type_name }}
                                                </td>
                                                <td class="text-center border_header_lot_detail_in_edit_list">
                                                    <v-text-field type="number" @keypress="isNumberPrice($event)" onpaste="return false" v-model="mat_detail.lot_details_price" hide-details="auto" :rules="[v => !!v || 'กรุณากรอกราคา']" required dense outlined></v-text-field>
                                                    <!-- <v-text-field type="number" v-model="mat_detail.price" hide-details="auto" :rules="[v => !!v || 'กรุณากรอกราคา']" required dense outlined v-if="mat_detail.unit_type == 1"></v-text-field>
                                                    <v-text-field type="number" v-model="mat_detail.price_other" hide-details="auto" :rules="[v => !!v || 'กรุณากรอกราคา']" required dense outlined v-if="mat_detail.unit_type == 2"></v-text-field> -->
                                                </td>
                                                <td class="text-center border_header_lot_detail_in_edit_list">
                                                    {{ mat_detail.unit_type == 1 && mat_detail.quantity ? currencyFormat(mat_detail.quantity * mat_detail.lot_details_price) :  mat_detail.unit_type == 2 && mat_detail.quantity ? currencyFormat(mat_detail.quantity * mat_detail.lot_details_price) : '' }}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="text-center border_header_lot_detail_in_edit_list" colspan="5">
                                                    มูลค่ารวม
                                                </td>
                                                <td class="text-center border_header_lot_detail_in_edit_list">
                                                    {{
                                                    currencyFormat(type_detail.detailList.reduce((sum,number) => { 
                                                        if(number.unit_type == 1){
                                                            return sum + (number.quantity * number.lot_details_price)
                                                        }
                                                        if(number.unit_type == 2){
                                                            return sum + (number.quantity * number.lot_details_price)
                                                        }
                                                    }, 0) )
                                                }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </v-simple-table>
                                </div>
                                <div class="pt-2 pb-2 text-center">
                                    <v-btn color="#28ab28" type="submit" class="white--text" width="20%" height="50">
                                        บันทึก
                                    </v-btn>
                                </div>
                            </v-form>
                        </div>
                    </v-col>
                </v-row>
            </div>
            <v-dialog v-model="open_alert_show_add" persistent max-width="600">
                <v-card>
                    <v-card-title>
                        สำเร็จ
                    </v-card-title>

                    <v-card-text>
                        แก้ไขล๊อตเข้าเรียบร้อย
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="success" text @click="confirmSuccess()">
                            ตกลง
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-card>
    </div>
</div>
</template>

<script>
import inoutstockall from '@/api/stock/stocklist/inoutstockall.js'
import {
    currencyFormat
} from '@/helper/numberformat.js'
export default {
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: true,
            open_alert_show_add: false,
            lot_detail: null,
            page_id: null,
            source_list: [],
            data: [],
        }
    },
    methods: {
        currencyFormat,
        async isNumber(evt) {
            evt = (evt) ? evt : window.event;
            let charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        async isNumberPrice(evt) {
            evt = (evt) ? evt : window.event;
            let charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        async lotInDetail() {
            this.loading_page = true
            inoutstockall.lotInDetail(this.$store.state.lotDetailInEditId).then((response) => {
                if (response.data.successful === true) {
                    this.lot_detail = response.data.lot
                    this.data = response.data.sources
                    response.data.sources.forEach((type_list, index_source) => {
                        this.source_list.push({
                            id: type_list.id,
                            source_name: type_list.source_name,
                        })
                        if (index_source == 0) {
                            this.page_id = type_list.id
                        }
                        type_list.typeList.forEach((detail_list, index_type) => {
                            detail_list.detailList.forEach((detail, index) => {
                                this.data[index_source]['typeList'][index_type]['detailList'][index]['quantity'] = detail.quantity.toString()
                                this.data[index_source]['typeList'][index_type]['detailList'][index]['unit_type_list'] = [{
                                    id: 1,
                                    unit_type: detail.unit_type,
                                    unit_type_name: detail.unit_type_name,
                                }, ]
                                if (detail.unit_other_id) {
                                    this.data[index_source]['typeList'][index_type]['detailList'][index]['unit_type_list'] = [{
                                            id: 1,
                                            unit_type: detail.unit_type,
                                            unit_type_name: detail.unit_type_name,
                                        },
                                        {
                                            id: 2,
                                            unit_type: detail.unit_other_id,
                                            unit_type_name: detail.unit_other_name,
                                        }
                                    ]
                                }
                            })
                        })
                    })
                    this.loading_page = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async lotInUpdate() {
            if (this.$refs.form_add.validate()) {
                this.loading_page = true
                let lot_detail_id = []
                let quantity = []
                let price = []
                let total = []
                let unit_id = []
                let unit_type = []
                this.data.forEach((sourcesDetail) => {
                    sourcesDetail.typeList.forEach((typeDetail) => {
                        typeDetail.detailList.forEach((detail) => {
                            lot_detail_id.push(detail.lot_detail_id)
                            quantity.push(parseFloat(detail.quantity))
                            if (detail.unit_type == 1) {
                                price.push(parseFloat(detail.lot_details_price))
                                let total_unit = parseFloat(detail.quantity) * parseFloat(detail.lot_details_price)
                                total.push(total_unit)
                                unit_id.push(detail.unit_type_list[0].unit_type)
                            } else {
                                price.push(parseFloat(detail.lot_details_price))
                                let total_unit = parseFloat(detail.quantity) * parseFloat(detail.lot_details_price)
                                total.push(total_unit)
                                unit_id.push(detail.unit_type_list[1].unit_type)
                            }
                            unit_type.push(detail.unit_type)
                        })
                    })
                })

                const total_price = total.reduce((sum, number) => {
                    return sum + number
                }, 0)
                const data = {
                    lot_detail_id: lot_detail_id,
                    quantity: quantity,
                    price:price,
                    total: total,
                    unit_id: unit_id,
                    unit_type: unit_type,
                    total_price: total_price,
                }
                inoutstockall.lotInUpdate(this.$store.state.lotDetailInEditId, data).then((response) => {
                    if (response.data.successful === true) {
                        this.open_alert_show_add = true
                        this.loading_page = false
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
            }
        },
        async page(id) {
            this.page_id = id
        },
        async confirmSuccess() {
            this.$router.push('/alllot')
        },
    },
    mounted() {
        this.lotInDetail()
    },
}
</script>

<style scoped>
.grid_lot_detail_in_edit_list {
    display: grid;
    grid-template-columns: auto auto;
}

.border_header_lot_detail_in_edit_list {
    border: thin solid rgba(0, 0, 0, 0.12);
}
</style>
